














































import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Action, Getter, Mutation } from 'vuex-class'
import InfiniteLoading from 'vue-infinite-loading'

import _get from 'lodash/get'

import { Book, Seller, Offer, OfferItem, SEARCH_TYPE } from '@/types'
import { OfferCartsState } from '@/store/offer-carts/types'
import { SellersState } from '@/store/sellers/types'
import GuidePricesTable from '@/components/GuidePricesTable.vue'
import SearchInput from '@/components/SearchInput.vue'
const namespace: string = 'sellers'

@Component({
  components: {
    GuidePricesTable,
    SearchInput,
    InfiniteLoading,
  },
})
export default class Sellers extends Vue {
  @State('sellers') private sellersState: SellersState | undefined
  @State('offerCarts') private offerCartsState: OfferCartsState | undefined

  @Action('getSellers', { namespace }) private getSellers: any
  @Action('getOffer', { namespace: 'offerCarts' }) private getOffer: any
  @Action('getActiveOffer', { namespace: 'offerCarts' }) private getActiveOffer: any
  @Action('uploadInventoryList', { namespace: 'offerCarts' }) private uploadInventoryList: any

  @Mutation('setActiveSeller', { namespace }) private setActiveSeller: any
  @Mutation('setEditSeller', { namespace }) private setEditSeller: any
  @Mutation('setUploadInventoryListRequired', { namespace: 'offerCarts' })
  private setUploadInventoryListRequired: any

  @Getter('getUserInfo', { namespace: 'auth' }) private userInfo: any
  @Getter('getActiveOffer', { namespace: 'offerCarts' }) private activeOffer: Offer | undefined
  @Getter('getAddOfferItemRequired', { namespace: 'offerCarts' }) private addOfferItemRequired:
    | OfferItem
    | undefined
  @Getter('getUploadInventoryListRequired', { namespace: 'offerCarts' })
  private uploadInventoryListRequired: File | undefined

  private helperText: string = `Type seller's name`
  private searchType: string = SEARCH_TYPE.SELLERS_SEARCH
  private searchKeyword: string = ''
  private infiniteId: number = new Date().getTime()
  private offset: number = 0
  private itemsPerPage: number = 10

  private sellers: Seller[] = []

  @Watch('userInfo')
  private userInfoChanged(newVal: any | undefined) {
    if (newVal) {
      this.infiniteId += 1
    }
  }

  private mounted(): void {}

  private destroyed(): void {}

  get gettingActiveOffer() {
    return _get(this.offerCartsState, ['requestPostOffer']) || false
  }

  private getAddress(seller: Seller) {
    return _get(seller, ['addressLine1']) || ''
  }

  private onSubmitKeyword(keyword: string): void {
    this.searchKeyword = keyword
    this.offset = 0
    this.infiniteId += 1
  }

  private infiniteHandler($state) {
    if (!this.userInfo) {
      $state.loaded()
      $state.complete()
      return
    }
    this.helperText = 'Searching...'
    this.getSellers({
      limit: this.itemsPerPage,
      offset: this.offset,
      order: [],
      keyword: this.searchKeyword,
      buyerUserId: _get(this.userInfo, ['id']),
    })
      .then(res => {
        $state.loaded()
        if (res.length < this.itemsPerPage) {
          $state.complete()
        }

        this.sellers = !this.offset ? res : [...this.sellers, ...res]

        this.offset += res.length || 0
        if (!res.length && this.offset === 0) {
          Vue.$toast.error('No matches found.')
        }
      })
      .catch(err => {
        $state.loaded()
        $state.complete()
      })
      .finally(() => {
        this.searchKeyword = ''
        this.helperText = `Type seller's name`
      })
  }

  private onClickAddButton() {
    this.setEditSeller({ seller: null })
    this.$router.push({ name: 'NewSeller' })
  }

  private onEditSeller(seller) {
    this.setEditSeller({ seller })
    this.$router.push({ name: 'EditSeller' })
  }

  private onClickSeller(seller) {
    if (this.addOfferItemRequired) {
      this.getActiveOffer({
        sellerId: seller.id,
        sellerUserId: _get(seller, ['sellerUser', 'userId']),
        buyerUserId: _get(this.userInfo, ['id']),
        userId: _get(this.userInfo, ['id']),
        offerItems: [this.addOfferItemRequired],
      })
        .then(() => {
          this.$router.replace({ name: 'OfferCart' })
        })
        .catch(err => {})
    } else if (this.uploadInventoryListRequired) {
      const formData = new FormData()
      formData.append('inventoryList', this.uploadInventoryListRequired, 'inventoryList')
      formData.append('sellerId', seller.id)
      formData.append('sellerUserId', _get(seller, ['sellerUser', 'userId']))
      formData.append('buyerUserId', _get(this.userInfo, ['id']))
      formData.append('userId', _get(this.userInfo, ['id']))
      formData.append('socketId', this.$socket.client.id)

      this.uploadInventoryList(formData)
        .then(res => {
          if (res && res.id) {
            this.getOffer(res.id).then(() => {
              if (this.$route.name !== 'OfferCart') {
                this.$router.replace({ name: 'OfferCart' })
              }
            })
          } else {
          }
        })
        .catch(err => {})
        .finally(() => {
          this.setUploadInventoryListRequired(null)
        })
    } else if (!this.activeOffer) {
      this.setActiveSeller({ seller })
      this.$router.replace({ name: 'Home' })
    }
  }
}
